export default __webpack_public_path__ + "locales/pl/Payments.json?hash=700cdbfb8755b41aef83876199173605";